module.exports = __webpack_public_path__ + "app/img/logoNoir.7d4e860e.png";